import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';

import PageTitle from '@/shared/components/layouts/PageTitle';
import { AppPath } from '@/shared/constants/path';

type TitleProps = {
  transactionId: string;
  onRefund: () => void;
};

const Title: FC<TitleProps> = ({ transactionId, onRefund }) => {
  const { t } = useTranslation(['payments', 'common']);

  const label = transactionId.split('-')[0];

  return (
    <PageTitle
      title={{
        text: `${t('payments:paymentId')}: ${label}`,
        tooltip: {
          title: transactionId,
          placement: 'right-end',
          arrow: true,
        },
      }}
      breadcrumbs={[
        {
          label: t('payments:payments'),
          icon: (
            <PaymentOutlinedIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
          to: AppPath.Payments,
        },
        {
          label: label,
          icon: (
            <PaymentOutlinedIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
      ]}
      actions={[
        {
          label: t('payments:issueRefund'),
          icon: null,
          button: {
            onClick: onRefund,
            variant: 'outlined',
            color: 'inherit',
          },
        },
      ]}
    />
  );
};

export default Title;
